import 'core-js/features/string/match-all';
import { ANALYSIS_PATTERN } from 'nike-ui/src/components/betbook/constants';

export const toAnalyseString = ct => {
    const participants = ct.pick?.participants;
    const tournament = ct.pick?.tournament;
    const market = ct.pick?.market;
    const text = participants.length > 1 ? `${participants[0]} vs ${participants[1]}` : `${tournament} - ${market}`;
    return `{Analysis:${ct.id}:${ct.ticket ? ct.ticket.stake : ct.stake}:${
        ct.ticket ? ct.ticket.win : ct.win
    }:${text}}`;
};

const toAnalyse = ([, displayStatus, id, stake, win, opponents]) => ({
    displayStatus,
    id,
    stake,
    win,
    opponents
});

const byId = (acc, item) => ({ ...acc, [item.id]: item });

export const analysesFromMessage = message =>
    (Array.from(message.matchAll(ANALYSIS_PATTERN)) || []).map(toAnalyse).reduce(byId, {});

export const stripAnalyses = str => str.replace(ANALYSIS_PATTERN, '').trim();
